import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const parseDotNetDate = (dateStr?: string) => {
  if (!dateStr) return "-";
  const match = dateStr.match(/\/Date\((\d+)[+-]?\d*\)\//);
  if (match) {
    const ts = parseInt(match[1], 10);
    return new Date(ts).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-');
  }
  if (dateStr.includes('T')) {
    const parts = dateStr.split('T')[0].split('-');
    if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return dateStr;
};

const APARViewDetails = () => {
  const routes = all_routes;
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state?.item;

  if (!item) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="alert alert-warning">
            No item selected. <button className="btn btn-link p-0 m-0 align-baseline" onClick={() => navigate(routes.apar.teamStatus)}>Go back</button>
          </div>
        </div>
      </div>
    );
  }

  const refNo = item.ReferenceNumber || item.referenceNumber || item.AppraisalID || item.id || 'N/A';
  const empName = item.EmployeeName || item.AppraiseeName || item.employeeName || '-';
  const empId = item.EmpID || item.EmployeeID || item.employeeId || '-';
  const templateName = item.Template || item.appraisalTemplateName || item.template || '-';
  const statusStr = (item.APARStatus || item.status || 'Pending').toString();
  const subStatusStr = item.APARSubStatus || item.aparSubstatus || '-';
  const roleStr = item.myRole || item.MyRole || item.Role || 'Appraisee';
  const startDateStr = parseDotNetDate(item.StartDate || item.FromDate || item.startDate);
  const endDateStr = parseDotNetDate(item.EndDate || item.ToDate || item.endDate);

  const statusNorm = statusStr.toLowerCase();
  let badgeClass = "badge bg-primary";
  if (statusNorm.includes('completed') || statusNorm.includes('approved') || statusNorm === 'a') badgeClass = "badge bg-success";
  else if (statusNorm.includes('rejected') || statusNorm === 'r') badgeClass = "badge bg-danger";
  else if (statusNorm.includes('pending') || statusNorm.includes('process') || statusNorm.includes('planning')) badgeClass = "badge bg-warning text-dark";

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">APAR Details</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.apar.dashboard}>Employee Appraisal</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.apar.teamStatus}>Team Status</Link>
                  </li>
                  <li className="breadcrumb-item active">View Details</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card shadow-sm border-0 module-card">
            <div className="card-header bg-white border-bottom p-4 d-flex justify-content-between align-items-center">
              <h5 className="mb-0 text-primary d-flex align-items-center">
                <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px' }}>
                  <i className="ti ti-file-description fs-2"></i>
                </div>
                <div>
                  <div className="fw-bold fs-16 text-dark">Appraisal Record Details</div>
                  <div className="fs-13 text-muted fw-normal mt-1">Ref / ID: {refNo}</div>
                </div>
              </h5>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate(-1)}>
                <i className="ti ti-arrow-left me-1"></i> Back
              </button>
            </div>
            
            <div className="card-body p-4">
              <div className="row g-4">
                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-hash me-1"></i> Reference / ID
                    </div>
                    <div className="fw-bold text-dark">{refNo}</div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-id me-1"></i> Employee ID
                    </div>
                    <div className="fw-bold text-dark">{empId}</div>
                  </div>
                </div>
                
                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-user me-1"></i> Employee Name
                    </div>
                    <div className="fw-bold text-dark">{empName}</div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-file-text me-1"></i> Template / Format
                    </div>
                    <div className="fw-bold text-dark">{templateName}</div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-calendar me-1"></i> Start Date
                    </div>
                    <div className="fw-bold text-dark">{startDateStr}</div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-calendar-due me-1"></i> End Date
                    </div>
                    <div className="fw-bold text-dark">{endDateStr}</div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-shield me-1"></i> Role
                    </div>
                    <div className="fw-bold text-dark">{roleStr}</div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-activity me-1"></i> Status
                    </div>
                    <div>
                      <span className={badgeClass}>
                        {statusStr}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="p-3 border rounded-3 bg-light h-100">
                    <div className="text-muted fs-13 mb-1 d-flex align-items-center">
                      <i className="ti ti-list-details me-1"></i> APAR Substatus
                    </div>
                    <div className="fw-bold text-warning">{subStatusStr}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default APARViewDetails;
